import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
} from '@angular/core';
import { UtilisateurService } from '../../../services/utilisateur.service';
import { Router } from '@angular/router';

@Component({
  selector: 'form-reset-collab',
  templateUrl: './form-reset.component.html',
  styleUrls: ['./form-reset.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormResetComponent {
  @Input() codeValidation!: string;
  @Input() codeValidationAlreadyValidated!: boolean;
  showSuccessReset = false;

  constructor(
    private readonly utilisateurService: UtilisateurService,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private readonly router: Router,
  ) {}

  public async onResetCodeValidation() {
    if (this.codeValidation !== null) {
      await this.utilisateurService.resetCodeValidation(this.codeValidation);
      this.showSuccessReset = true;
    }

    this.changeDetectorRef.detectChanges();
  }

  public async backToConnexion() {
    await this.router.navigate(['/connexion'], {});
  }
}
